import { FPageConfig } from "../typings";

export const getRoutePrefix = (pageInfo: FPageConfig) => {
    // 进行微应用的路由模式，切不是原生路由模式
    const { hash } = window.location;
    const inputhash = pageInfo.path.startsWith('/#') ? pageInfo.path.slice(2) : pageInfo.path;
    if (hash.endsWith(inputhash)) {
      // 地址已经加载，开始添加路由
      const firstIndex = hash.indexOf(inputhash);
      return hash.slice(hash.startsWith('#') ? 1 : 0, firstIndex);
    }
    return hash;
};
